export const routeUrls = {
    authorize: '/authorize',
    loginCallback: '/signin-oidc',
    authorizeError: '/not-authorized',
    logout: '/logout',
    forgotPassword: '/forgot-password',
    dashboard: '/dashboard',
    services: '/services',
    documents: '/documents',
    contracts: '/contracts',
    trips: '/Trips',
    trip:'/tripdetails/:id',
    fleetAndRoute: '/fleet-and-route',
    settings: '/settings',
    profile: '/profile',
    errorPage:'/errorPage',
    app:'https://applink.mobiledatacollection.it/arcese/',
    tripDocuments: '/tripdetails/:id/documents',
}

export const protectedRoutes = [
    routeUrls.dashboard,
    routeUrls.services,
    routeUrls.documents,
    routeUrls.contracts,
    routeUrls.fleetAndRoute,
    routeUrls.settings,
    routeUrls.trips,
    routeUrls.trip,
    
    routeUrls.tripDocuments,
]